import { useListAllpayUsers } from '@/api/trafikportalen/trafikportalenAPI';
import { useListCardCredits } from '@/api/trafikportalen/trafikportalenAPI';

export const useDepartmentCreditInfo = (
  departmentId: string,
): {
  allpayCredit: number;
  cardCredit: number;
  totalSpent: number;
  isLoading: boolean;
} => {
  const { data: allpayUsers, isLoading: allpayIsLoading } = useListAllpayUsers({
    department_id: departmentId,
  });
  const { data: cardCredits, isLoading: cardCreditsIsLoading } =
    useListCardCredits();

  if (allpayIsLoading || cardCreditsIsLoading)
    return {
      allpayCredit: 0,
      cardCredit: 0,
      totalSpent: 0,
      isLoading: true,
    };

  const allpayCredit =
    allpayUsers?.reduce((acc, user) => {
      return acc + user.credit;
    }, 0) ?? 0;

  const cardCredit =
    cardCredits?.reduce((acc, card) => {
      if (card.department_id !== departmentId) {
        return acc;
      }

      return acc + card.credit;
    }, 0) ?? 0;

  return {
    allpayCredit,
    cardCredit,
    totalSpent: allpayCredit + cardCredit,
    isLoading: false,
  };
};
